import React, { memo, forwardRef, useCallback } from 'react';
import { View } from 'react-native';
import { Text } from '@redlink/components/atoms';
import { createUseStyle } from '@redlink/assets/styles';
import 'react-input-color';

export const ColorInput = memo(
  forwardRef(({ style, title, value, onChange, disabled = false }, ref) => {
    const { styles } = useStyle();

    const onChangeColor = useCallback(
      (e) => {
        onChange && onChange(e.target.value);
      },
      [onChange]
    );

    return (
      <View
        style={[style, styles.container, disabled && styles.containerDisabled]}
        pointerEvents={disabled ? 'none' : 'auto'}
      >
        <Text style={styles.titleText}>{title}</Text>
        <input type="color" onChange={onChangeColor} {...{ value }} />
      </View>
    );
  })
);

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    backgroundColor: colors.gray7,
    borderRadius: 5,
    paddingHorizontal: 6,
    paddingVertical: 6,
    flexDirection: 'row',
    alignItems: 'center',
  },
  containerDisabled: {
    opacity: 0.5,
  },
  titleText: {
    flex: 1,
    fontSize: 12,
    color: colors.black
  },
  colorThumbnail: {
    width: 18,
    height: 18,
    borderWidth: 1,
    borderColor: colors.white,
  },
}));
